const TOP_BAR = [
  {
    name: 'basic_element',
    icon: 'icon-tuceng-kuaijiegongneng',
    items: ['text', 'image']
  },
  {
    name: 'background',
    icon: 'icon-tuceng-beijing',
    items: ['background', 'scale']
  },
  {
    name: 'time',
    icon: 'icon-tuceng-zhizhenshijian',
    items: ['analog_clock', 'digital_clock' /* 'digitalClock' 'progress_clock' */]
  },
  {
    name: 'date',
    icon: 'icon-tuceng-riqi',
    items: ['date', 'lunar', 'week']
  },
  {
    name: 'workout_health',
    icon: 'icon-tuceng-xinshuai',
    items: ['heart_rate', 'calorie', 'pai', 'pai_daily', 'stand', 'step', 'distance', 'stress', 'spo2', 'training_load', 'vo2max', 'altitude', 'sleep', 'bio_charge', 'hrv', 'lthr', 'ltpace', 'recovery_time', 'month_run_times', 'floor']
  },
  {
    name: 'weather',
    icon: 'icon-tuceng-tianqi',
    items: ['weather', 'temperature', 'sun', 'humidity', 'uvi', 'moon', 'moon_rise', 'moon_set', 'altimeter', 'wind']
  },
  {
    name: 'system',
    icon: 'icon-tuceng-xitong',
    items: ['system', 'battery']
  },
  // {
  //     name: 'communication',
  //     icon: 'icon-caidan-tongxun',
  //     items: ['message', 'phone'],
  // },
  {
    name: 'editable',
    icon: 'icon-caidan-kebianji',
    items: ['component', 'editable_bg']
  },
  {
    name: 'animation',
    icon: 'icon-tuceng-xitong',
    items: ['animation']
  }
]

export default TOP_BAR
